import styled from "styled-components";

import { device } from "../../config/sizes";

export const HeadlineWrapper = styled.div`
  h2 {
    margin-bottom: 0;
  }

  div {
    margin-bottom: 2em;
  }

`;

export const DeepDiveWrapper = styled.div<{ position: string }>`
  position: fixed;
  ${({ position }) =>
    position === "left" ? "left: -100vw;" : "right: -100vw;"}
  width: 100vw;
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const DeepDiveContent = styled.div`
  display: flex;
  flex-direction: column;
  
  img {
    width: 70%;
    align-self: center;
    padding: 5vh 0 5vh 0;

    
    @media ${device.mobile} {
      width: 100%;
    }
    
    img.width-fifty {
      width: 50%;
    }

    img.width-eighty {
      width: 80%;
    }

    img.content {
      padding: 5vh 0 5vh 0;
    }
  }
`;

export const DeepDiveLinkLayout = styled.div<{ direction?: string }>`
  display: flex;
  flex-direction: column;
  line-height: 1.3;
  font-weight: bold;
  font-size: 1.35em;
  font-family: Space Mono;
  margin: 2rem 0;
  align-self: ${({ direction }) => (direction == "right" ? "flex-end" : "flex-start")};;
`;

export const Overline = styled.p`
  font-size: 0.5em;
  font-weight: lighter;
  padding-bottom: 0.25em;

  a {
    text-decoration: none;
    color: black;
  }

  @media ${device.mobile} {
    display: none;
  }

  @media ${device.tablet} {
    margin-right: 4em !important;
    margin-left: 8em !important;
    display: none;
  }
`;

export const ArrowWrapper = styled.div<{ direction: string }>`
  display: flex;
  flex-direction: row;
  margin-left: ${({ direction }) => (direction == "right" ? "0" : "-4em")};
  margin-right: ${({ direction }) => (direction == "right" ? "-4em" : "0")};;
  align-items: center;
  justify-content: center;

  .arrow {
    opacity: 0.2;
    width: auto;
  }

  .arrowLeft {
    transform: rotate(180deg);
  }

  @media ${device.tablet} {
    margin: 0 0 0 ${({ direction }) => (direction == "right" ? "2em" : "0em")};
  }

  @media ${device.mobile} {
    margin: 0;
  }

  p {
    width: inherit;
    padding-top: 0.25em;
    padding: ${({ direction }) =>
      direction == "right" ? "0 4em 0 0" : "0 0 0 4em"};

    @media ${device.mobile} {
      padding: ${({ direction }) =>
        direction == "right" ? "0 2em 0 0" : "0 0 0 2em"};
    }
  }

  div {
    height: 100%;
  }
`;

export const TextWrapper = styled.div<{ direction: string }>`
  display: flex;
  flex-direction: column;
  font-family: "Space Mono", Courier, monospace;
  font-weight: bold;
  transition: all 0.75s ease-in-out;
  flex: 1 0 auto;
  z-index: 1;

  :hover {
    transform: translate(
      ${({ direction }) => (direction == "right" ? "2vw" : "-2vw")}
    );

    transition: all 0.75s ease-in-out;
    cursor: pointer;
  }

  p {
    margin: -0.35em 0 0 0;
    text-align: ${({ direction }) => direction};
  }
`;

export const Underline = styled.div<{ direction: string; color: string }>`
  background-color: ${({ color }) => color};
  margin-left: ${({ direction }) => (direction == "right" ? "5vw" : "-50vw")};
  margin-right: ${({ direction }) => (direction == "right" ? "-50vw" : "5vw")};
  height: 0.6em;
  margin-top: -0.75em;
  z-index: 0;
`;

export const Text = styled.p`
  font-size: 1.4rem;
  font-style: italic;
  margin-top: 1rem;
  letter-spacing: 0.075em;

  a {
    text-decoration: none;
    color: black;
  }

  @media ${device.mobile} {
    font-size: 1em;
  }
`;
